var _defs, _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _path5, _path6, _g, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSystemBranding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 157.706,
    height: 156.999,
    viewBox: "0 0 157.706 156.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1.698,
    y1: 0.844,
    x2: 3.961,
    y2: -0.042,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d93232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6c0909"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -2.245,
    y1: 0.5,
    x2: 1.055,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bdb4b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#746e6e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -2.484,
    y1: 0.967,
    x2: 3.175,
    y2: 0.081,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -1.42,
    y1: 0.801,
    x2: 4.239,
    y2: -0.086,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e20909"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -1.21,
    y1: 0.673,
    x2: 3.419,
    y2: 0.311,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0,
    x2: 1,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -1.852,
    y1: 0.723,
    x2: 2.776,
    y2: 0.361,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.074,
    stopColor: "#0ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#36b2ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.365,
    stopColor: "#72bc79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#a4c54e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665,
    stopColor: "#cbcb2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.798,
    stopColor: "#e7d013"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914,
    stopColor: "#f8d305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -0.982,
    y1: 0.655,
    x2: 3.646,
    y2: 0.293,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff001c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd400"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1308",
    x: 35.536,
    y: 38.68,
    width: 85.64,
    height: 85.64,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7686",
    "data-name": "Group 7686",
    transform: "translate(-6.5 -6.501)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7687",
    "data-name": "Group 7687",
    transform: "translate(-54.274 -41.805)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7688",
    "data-name": "Group 7688",
    transform: "translate(60.775 48.305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7687-2",
    "data-name": "Group 7687",
    transform: "translate(0 0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2183",
    "data-name": "Path 2183",
    d: "M175.872,84.344l-33.82,44.68-33.82-44.68Z",
    transform: "translate(-63.697 -50.524)",
    fill: "#c7c8ca"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2184",
    "data-name": "Path 2184",
    d: "M189.095,95.916l-44.823,33.82,44.823,33.82Z",
    transform: "translate(-65.916 -51.237)",
    fill: "#780e0e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2185",
    "data-name": "Path 2185",
    d: "M108.232,176.635l33.82-44.68,33.82,44.68Z",
    transform: "translate(-63.697 -53.456)",
    fill: "#c7c8ca"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2186",
    "data-name": "Path 2186",
    d: "M96.814,163.556l44.536-33.82L96.814,95.916Z",
    transform: "translate(-62.994 -51.237)",
    fill: "#ff3535"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1300",
    "data-name": "Rectangle 1300",
    width: 47.829,
    height: 47.829,
    transform: "translate(44.536 33.82) rotate(-45)",
    fill: "url(#linear-gradient)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1301",
    "data-name": "Rectangle 1301",
    width: 47.829,
    height: 47.829,
    transform: "translate(0 78.5) rotate(-45)",
    fill: "url(#linear-gradient-2)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1302",
    "data-name": "Rectangle 1302",
    width: 47.829,
    height: 47.829,
    transform: "translate(89.359 78.5) rotate(-45)",
    stroke: "#cecece",
    strokeWidth: 1,
    fill: "url(#linear-gradient-3)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1303",
    "data-name": "Rectangle 1303",
    width: 47.829,
    height: 47.829,
    transform: "translate(44.536 123.179) rotate(-45)",
    fill: "url(#linear-gradient-4)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2187",
    "data-name": "Path 2187",
    d: "M142.052,48.305l-33.82,33.82,33.82,33.82Z",
    transform: "translate(-63.697 -48.305)",
    fill: "url(#linear-gradient-5)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2188",
    "data-name": "Path 2188",
    d: "M94.595,95.916l-33.82,33.82,33.82,33.82Z",
    transform: "translate(-60.775 -51.237)",
    fill: "url(#linear-gradient-6)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2189",
    "data-name": "Path 2189",
    d: "M189.817,95.916,156,129.736l33.82,33.82Z",
    transform: "translate(-66.638 -51.237)",
    opacity: 0.43,
    fill: "url(#linear-gradient-7)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2190",
    "data-name": "Path 2190",
    d: "M108.232,177.347l33.82,33.82v-67.64Z",
    transform: "translate(-63.697 -54.168)",
    opacity: 0.43,
    fill: "url(#linear-gradient-8)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1304",
    "data-name": "Rectangle 1304",
    width: 26.323,
    height: 26.323,
    transform: "translate(59.743 49.027) rotate(-45)",
    fill: "#231f20",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1305",
    "data-name": "Rectangle 1305",
    width: 26.425,
    height: 26.425,
    transform: "translate(30.27 78.5) rotate(-45)",
    fill: "#231f20",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1306",
    "data-name": "Rectangle 1306",
    width: 26.323,
    height: 26.323,
    transform: "translate(59.743 107.972) rotate(-45)",
    fill: "#231f20",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1307",
    "data-name": "Rectangle 1307",
    width: 26.221,
    height: 26.221,
    transform: "translate(89.359 78.5) rotate(-45)",
    fill: "#231f20",
    opacity: 0.1,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Rectangle_1308)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1308-2",
    "data-name": "Rectangle 1308",
    width: 47.829,
    height: 47.829,
    transform: "translate(44.54 78.5) rotate(-45)",
    fill: "#f1f2f2"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2191",
    "data-name": "Path 2191",
    d: "M142.052,95.916l-33.82,33.82,33.82,33.82Z",
    transform: "translate(-63.697 -51.237)",
    fill: "#fff"
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_890",
    "data-name": "Path 890",
    d: "M157.1,130.515a3.227,3.227,0,0,0-2.507-3.081,3.55,3.55,0,0,0-1.961.1,3.406,3.406,0,0,0-4.286-2.2l-.125.043a3.405,3.405,0,0,0-4.221-2.1v-.434c0-1.047.016-2.095-.007-3.141a3.322,3.322,0,1,0-6.64.237h0q-.008,6.848,0,13.693v.394a18.778,18.778,0,0,1-1.17-1.6,3.905,3.905,0,0,0-6.518,4.3q2.886,4.616,5.83,9.195a7.3,7.3,0,0,0,3.571,2.923,21.392,21.392,0,0,0,2.364.631h7.945a3,3,0,0,1,.328-.069,8.485,8.485,0,0,0,7.309-7.169,23.921,23.921,0,0,0,.1-2.793c.008-2.976.02-5.953-.014-8.929Zm-2.255,10.325A6.179,6.179,0,0,1,150.164,147a6.507,6.507,0,0,1-1.529.2c-2.169.021-4.338.031-6.507,0a5.544,5.544,0,0,1-4.84-2.682q-2.85-4.435-5.654-8.9a1.636,1.636,0,0,1,1.224-2.586,1.575,1.575,0,0,1,1.5.764q2.477,3.685,4.961,7.369c.069.1.144.2.217.306l.078-.016V120.161a2.744,2.744,0,0,1,.046-.6,1.026,1.026,0,0,1,1.083-.807,1.06,1.06,0,0,1,.973.949,3.873,3.873,0,0,1,.008.418v11H144v-.4c0-1.4,0-2.8,0-4.2a1.053,1.053,0,1,1,2.1-.122c0,.028,0,.057,0,.086.007.1,0,.2,0,.3v4.336h2.251c.007-.121.017-.253.017-.386,0-.719,0-1.439,0-2.155a1.049,1.049,0,1,1,2.092-.16,1.068,1.068,0,0,1,0,.11c.023.719.008,1.437.008,2.155v.437h2.248c.01-.181.017-.367.033-.551a1.039,1.039,0,0,1,2.074.014c.008.1.008.2.008.3,0,3.316.008,6.633,0,9.949Z",
    transform: "translate(-4.203 -4.199)",
    fill: "url(#linear-gradient-9)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_891",
    "data-name": "Path 891",
    d: "M142.412,110.347h-2.273v3.116h2.273Z",
    transform: "translate(-4.887 -3.82)",
    fill: "url(#linear-gradient-10)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_892",
    "data-name": "Path 892",
    d: "M138.286,114.1l-2.114-2.321L134.5,113.3l2.113,2.318Z",
    transform: "translate(-4.539 -3.908)",
    fill: "url(#linear-gradient-11)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_893",
    "data-name": "Path 893",
    d: "M146.905,119.574l3.121-.287c-.069-.764-.14-1.493-.209-2.259l-3.124.292c.069.764.139,1.474.208,2.254Z",
    transform: "translate(-5.29 -4.231)",
    fill: "url(#linear-gradient-12)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_894",
    "data-name": "Path 894",
    d: "M135.75,117.314l-3.119-.292c-.069.777-.139,1.508-.208,2.262l3.12.287c.069-.77.136-1.5.2-2.256Z",
    transform: "translate(-4.411 -4.231)",
    fill: "url(#linear-gradient-13)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_895",
    "data-name": "Path 895",
    d: "M147.925,113.306l-1.676-1.53-2.112,2.325,1.675,1.529,2.112-2.32Z",
    transform: "translate(-5.133 -3.908)",
    fill: "url(#linear-gradient-14)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemBranding);
export default __webpack_public_path__ + "static/media/system_branding.8b900380a0149de7b5f020f8d29d1adb.svg";
export { ForwardRef as ReactComponent };